import React from 'react';
import TenantsCRUD from '../components/superadmin/TenantsCRUD';

const SuperadminTenantsPage = ({ activeTab = 'tenants/comparison-chart', onProxyLogin, onNavigate }) => {
  return (
    <TenantsCRUD
      activeTab={activeTab}
      onNavigate={onNavigate}
      onProxyLogin={onProxyLogin}
      onCreateTenant={() => onNavigate?.('tenants/create')}
    />
  );
};

export default SuperadminTenantsPage;
